export default __webpack_public_path__ + "static/media/logo512-white.ca15088d.png";